export const INFINI_TRANSLATIONS = {
  fr: {
    "infini.title": "Mon Infini",
    "infini.eyebrow": "INFINI D’INFINI",
    "infini.subtitle": "Organisez un cycle temporel défini ou un parcours flexible, toujours sous votre contrôle.",
    "infini.intro": "Définissez vos étapes, suivez votre progression et consultez votre historique privé. Les fonctions de mémoire durable et de possibilités restent fermées pendant cette bêta.",
    "infini.skip": "Aller au contenu",
    "infini.home_aria": "Tableau de bord Mon Infini",
    "infini.private_space": "Espace personnel privé",
    "infini.back_eternua": "Retour à Eternua",
    "infini.nav.label": "Navigation Mon Infini",
    "infini.nav.dashboard": "Tableau de bord",
    "infini.nav.new": "Nouveau cycle",
    "infini.nav.entries": "Éléments conservés",
    "infini.nav.history": "Historique",
    "infini.nav.graph": "Constellation",
    "infini.nav.privacy": "Confidentialité",
    "infini.badges.label": "Garanties de Mon Infini",
    "infini.badge.private": "Privé",
    "infini.badge.no_ai": "Sans IA active",
    "infini.badge.memory": "Contrôle humain",
    "infini.no_ai_notice": "Aucune IA ne lit, ne modifie ou n’exécute vos actions.",
    "infini.privacy_controls": "Comprendre vos contrôles de confidentialité",
    "infini.loading": "Chargement de votre espace privé…",
    "infini.retry": "Réessayer",
    "infini.error.offline": "Connexion indisponible",
    "infini.error.title": "Impossible d’ouvrir cet espace",
    "infini.error.text": "La demande n’a pas pu être traitée.",
    "infini.error.conflict": "Une version plus récente est disponible. Rechargez avant de continuer.",
    "infini.error.precondition": "La version de cette ressource manque. Un rechargement est nécessaire.",
    "infini.error.throttled": "Trop de demandes ont été envoyées. Réessayez dans un instant.",
    "infini.disabled.title": "Mon Infini est actuellement en préparation.",
    "infini.disabled.text": "Cet espace privé sera ouvert progressivement. Aucune donnée de cycle n’est affichée tant que la fonctionnalité reste fermée.",
    "infini.create": "Ouvrir un cycle",
    "infini.understand_memory": "Comprendre la confidentialité",
    "infini.empty.title": "Votre premier cycle commence par une intention",
    "infini.empty.text": "Ouvrez un brouillon, définissez librement ses étapes puis décidez quand le démarrer.",
    "infini.current": "En ce moment",
    "infini.primary_cycle": "Votre cycle principal",
    "infini.cycle.primary": "Cycle principal",
    "infini.continue": "Continuer",
    "infini.progress": "Progression",
    "infini.next_step": "Prochaine étape",
    "infini.target_date": "Date cible",
    "infini.none": "Aucune",
    "infini.diagram.title": "Diagramme d’un cycle Infini",
    "infini.diagram.description": "Une boucle dorée délimite le cycle, un parcours flexible le traverse et plusieurs possibilités s’ouvrent à sa sortie.",
    "infini.diagram.boundary": "Cadre temporel",
    "infini.diagram.flexible": "Parcours flexible",
    "infini.diagram.trace": "Trace choisie",
    "infini.diagram.possibilities": "Nouveaux possibles",
    "infini.cycle.start": "Démarrer",
    "infini.cycle.pause": "Mettre en pause",
    "infini.cycle.resume": "Reprendre",
    "infini.cycle.complete": "Terminer",
    "infini.cycle.cancel": "Annuler",
    "infini.cycle.archive": "Archiver",
    "infini.cycle.duplicate": "Dupliquer",
    "infini.steps.title": "Étapes du cycle",
    "infini.steps.add": "Ajouter une étape personnelle",
    "infini.steps.optional": "Étape facultative",
    "infini.trace.title": "Coffre de traces",
    "infini.trace.create": "Créer une trace",
    "infini.trace.hidden": "Contenu protégé — ouvrez cette trace pour le consulter.",
    "infini.consent.approve": "Approuver explicitement",
    "infini.consent.revoke": "Retirer mon consentement",
    "infini.consent.erase": "Effacer définitivement le contenu",
    "infini.possibilities.title": "Constellation des possibles",
    "infini.possibilities.create": "Proposer une possibilité",
    "infini.possibilities.no_agent": "Chaque possibilité indique sa source. Aucune suggestion n’est produite par une IA.",
    "infini.links.title": "Liens entre cycles",
    "infini.links.create": "Relier les cycles",
    "infini.graph.title": "Constellation des cycles",
    "infini.graph.list": "Liste accessible",
    "infini.graph.truncated": "La vue a été bornée pour préserver la confidentialité et les performances.",
    "infini.privacy.title": "Confidentialité et mémoire",
    "infini.privacy.session": "Mémoire de session",
    "infini.privacy.cycle": "Mémoire du cycle",
    "infini.privacy.durable": "Mémoire durable choisie",
    "infini.privacy.no_export": "L’API Infini de cette phase ne fournit pas encore d’export global : l’interface ne simule pas cette action.",
    "infini.history.title": "Historique privé",
    "infini.history.empty": "Aucun cycle dans cette vue",
    "infini.future_agents.title": "Les 44 IA humaines — préparation future",
    "infini.future_agents.inactive": "Aucun agent n’est actif et aucune action agent n’est disponible dans Mon Infini.",
  },
  en: {
    "infini.title": "My Infinity",
    "infini.eyebrow": "INFINITY OF INFINITIES",
    "infini.subtitle": "Organize a defined time cycle or a flexible path, always under your control.",
    "infini.intro": "Define your steps, follow your progress and consult your private history. Durable memory and possibility features remain closed during this beta.",
    "infini.skip": "Skip to content",
    "infini.home_aria": "My Infinity dashboard",
    "infini.private_space": "Private personal space",
    "infini.back_eternua": "Back to Eternua",
    "infini.nav.label": "My Infinity navigation",
    "infini.nav.dashboard": "Dashboard",
    "infini.nav.new": "New cycle",
    "infini.nav.entries": "Saved items",
    "infini.nav.history": "History",
    "infini.nav.graph": "Constellation",
    "infini.nav.privacy": "Privacy",
    "infini.badges.label": "My Infinity guarantees",
    "infini.badge.private": "Private",
    "infini.badge.no_ai": "No active AI",
    "infini.badge.memory": "Human control",
    "infini.no_ai_notice": "No AI reads, edits or executes your actions.",
    "infini.privacy_controls": "Understand your privacy controls",
    "infini.loading": "Loading your private space…",
    "infini.retry": "Try again",
    "infini.error.offline": "Connection unavailable",
    "infini.error.title": "Unable to open this space",
    "infini.error.text": "The request could not be processed.",
    "infini.error.conflict": "A newer version is available. Reload before continuing.",
    "infini.error.precondition": "This resource version is missing. Reloading is required.",
    "infini.error.throttled": "Too many requests were sent. Try again shortly.",
    "infini.disabled.title": "My Infinity is currently being prepared.",
    "infini.disabled.text": "This private space will open gradually. No cycle data is shown while the feature remains closed.",
    "infini.create": "Open a cycle",
    "infini.understand_memory": "Understand privacy",
    "infini.empty.title": "Your first cycle begins with an intention",
    "infini.empty.text": "Open a draft, define its steps freely, then decide when to start it.",
    "infini.current": "Right now",
    "infini.primary_cycle": "Your primary cycle",
    "infini.cycle.primary": "Primary cycle",
    "infini.continue": "Continue",
    "infini.progress": "Progress",
    "infini.next_step": "Next step",
    "infini.target_date": "Target date",
    "infini.none": "None",
    "infini.diagram.title": "Infinity cycle diagram",
    "infini.diagram.description": "A golden loop marks the cycle, a flexible path crosses it and several possibilities open beyond it.",
    "infini.diagram.boundary": "Time boundary",
    "infini.diagram.flexible": "Flexible path",
    "infini.diagram.trace": "Chosen trace",
    "infini.diagram.possibilities": "New possibilities",
    "infini.cycle.start": "Start",
    "infini.cycle.pause": "Pause",
    "infini.cycle.resume": "Resume",
    "infini.cycle.complete": "Complete",
    "infini.cycle.cancel": "Cancel",
    "infini.cycle.archive": "Archive",
    "infini.cycle.duplicate": "Duplicate",
    "infini.steps.title": "Cycle steps",
    "infini.steps.add": "Add a personal step",
    "infini.steps.optional": "Optional step",
    "infini.trace.title": "Trace vault",
    "infini.trace.create": "Create a trace",
    "infini.trace.hidden": "Protected content — open this trace to read it.",
    "infini.consent.approve": "Approve explicitly",
    "infini.consent.revoke": "Withdraw my consent",
    "infini.consent.erase": "Permanently erase content",
    "infini.possibilities.title": "Possibility constellation",
    "infini.possibilities.create": "Propose a possibility",
    "infini.possibilities.no_agent": "Each possibility identifies its source. No suggestion is produced by AI.",
    "infini.links.title": "Links between cycles",
    "infini.links.create": "Link cycles",
    "infini.graph.title": "Cycle constellation",
    "infini.graph.list": "Accessible list",
    "infini.graph.truncated": "This view was bounded to preserve privacy and performance.",
    "infini.privacy.title": "Privacy and memory",
    "infini.privacy.session": "Session memory",
    "infini.privacy.cycle": "Cycle memory",
    "infini.privacy.durable": "Chosen durable memory",
    "infini.privacy.no_export": "This phase of the Infinity API does not provide a global export yet; the interface does not simulate one.",
    "infini.history.title": "Private history",
    "infini.history.empty": "No cycles in this view",
    "infini.future_agents.title": "The 44 human AIs — future preparation",
    "infini.future_agents.inactive": "No agent is active and no agent action is available in My Infinity.",
  },
};
